export * from './v1/pages'
export * from './v2/pages'
export * from './v3/pages'
export * from './v4/pages'
export * from './v5/pages'
export * from './v6/pages'

export * from './shopify/pages'
